import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GridOptions, RowClickedEvent } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { ButtonCellRendererComponent } from '../button-cell-renderer/button-cell-renderer.component';

@Component({
    selector: 'sentry-data-grid',
    templateUrl: './data-grid.component.html',
    standalone: true,
    imports: [AgGridModule, ButtonCellRendererComponent]
})
export class DataGridComponent implements OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data!: any[];
  @Input() searchText!: string | undefined;
  @Input() gridOptions: GridOptions = {};
  @Input() hasDetails = true;

  @Output() detailsClick$ = new EventEmitter<RowClickedEvent>();

  agrigatedGridOptions: GridOptions = {};

  readonly domLayout = 'autoHeight';

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.['gridOptions'] && changes?.['gridOptions']?.['currentValue']) {
      if (this.hasDetails) {
        this.agrigatedGridOptions = {
          ...this.gridOptions,
          columnDefs: [
            ...(this.gridOptions.columnDefs ?? []),
            {
              field: 'Actions',
              cellRenderer: ButtonCellRendererComponent,
              cellRendererParams: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                clicked: (field: any) => {
                  this.detailsClick$.emit(field);
                },
              },
              pinned: 'right',
              resizable: true,
              width: 120
            },
          ],
        };
        return;
      }

      this.agrigatedGridOptions = this.gridOptions;
    }
  }
}
